import React from 'react';
import styles from './MessageBox.module.scss';

type MessageBoxProps = {
  colorScheme?: 'action';
  children: React.ReactNode;
};

const MessageBox: React.FC<MessageBoxProps> = ({ children, colorScheme = 'action' }) => {
  return <div className={`${styles.messageBox} ${styles[colorScheme]}`}>{children}</div>;
};

export default MessageBox;
